export class Nav{
    constructor(openNav, closeNav){
        this.openNav = openNav;
        this.closeNav = closeNav;
    }
    init(){
        const openNav = document.getElementById(this.openNav);
        const closeNav = document.getElementById(this.closeNav);
        const navItems = document.querySelectorAll('#menu li a');
        const body = document.querySelector('body.joincf');
        const siteLogo = document.querySelector('#site-header a');
        const joinClickMobile = document.querySelector('#join_click_mobile');
        
        if(joinClickMobile) {
            
            joinClickMobile.addEventListener('click', ()=>{
                body.classList.remove('nav-open');
                this.close;
            });
        }
        if(openNav){
            openNav.addEventListener('click', ()=>{
                body.classList.add('nav-open');
            });
        }
       if(closeNav){
           closeNav.addEventListener('click', ()=>{
               body.classList.remove('nav-open');
           });
       }
       if(navItems){
           navItems.forEach((navItem)=>{
               navItem.addEventListener('click', ()=>{
                   setTimeout(()=>{
                       body.classList.remove('nav-open');
                   }, 200);
               });
           });
       }
        if(siteLogo){
            siteLogo.addEventListener('click', ()=>{
                setTimeout(()=>{
                    body.classList.remove('nav-open');
                }, 200);
            });
        }
        // joinUs.addEventListener('click', ()=>{
        //     setTimeout(()=>{
        //         body.classList.remove('nav-open');
        //     }, 200);
        // });
    }
}
